import React, { useEffect, useState } from "react";
import { Modal, Spin, message, Pagination } from "antd";
import promosApi from "../../api/promosApi";
import PromoCard from "../../components/PromoCard/PromoCard";
import "../AddUserModal/style.css";

const SubscribePromoModal = ({ visible, onClose, userId, onSubscribed }) => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [subscribingId, setSubscribingId] = useState(null);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const fetchPromos = async () => {
        try {
            setLoading(true);

            // 1. Получаем только ACTIVE промо с пагинацией
            const { data: activePromos, total: totalCount } = await promosApi.promosApi.getPaginatedPromos({
                status: 'ACTIVE',
                page,
                limit: 20,
            });

            // 2. Получаем список уже подписанных промо
            const userEntries = await promosApi.userPromos.getPromos(userId);
            const subscribedIds = new Set(userEntries.map(e => e.promo.id));

            // 3. Исключаем подписанные промо
            const available = activePromos.filter(p =>
                !subscribedIds.has(p.id) &&
                (p.category?.category_name || p.category_name)
            );

            setList(available);
            setTotal(totalCount);
        } catch (e) {
            console.error(e);
            message.error("Не удалось загрузить список промо");
        } finally {
            setLoading(false);
        }
    };

    const handleSubscribe = async (promo) => {
        setSubscribingId(promo.id);
        try {
            await promosApi.userPromos.subPromo(userId, promo.id);
            message.success("Пользователь подписан на промо");
            onSubscribed();
            onClose();
        } catch (e) {
            console.error(e);
            message.error("Не удалось подписать на промо");
        } finally {
            setSubscribingId(null);
        }
    };

    useEffect(() => {
        if (visible) {
            fetchPromos();
        }
    }, [visible, page]);

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            title="Выберите промо для подписки"
            width={480}
            centered
            className="custom-modal"
            maskStyle={{ background: "rgba(0,0,0,0.55)", backdropFilter: "blur(6px)" }}
            styles={{
                body: {
                    maxHeight: "70vh",
                    overflowY: "auto",
                    backgroundColor: "transparent",
                    padding: "16px 20px 20px",
                },
            }}
        >
            {loading ? (
                <div className="flex h-36 items-center justify-center">
                    <Spin className="[&_.ant-spin-dot-item]:!bg-emerald-400" />
                </div>
            ) : list.length === 0 ? (
                <p className="py-8 text-center text-sm text-white/45">Нет доступных промо</p>
            ) : (
                <>
                    <div className="flex flex-col gap-3">
                        {list.map((promo) => (
                            <div
                                key={promo.id}
                                className="relative cursor-pointer rounded-xl transition-transform hover:scale-[1.01]"
                                onClick={() => !subscribingId && handleSubscribe(promo)}
                            >
                                {subscribingId === promo.id && (
                                    <div className="absolute inset-0 z-[1] flex items-center justify-center rounded-xl bg-black/55 backdrop-blur-[2px]">
                                        <Spin className="[&_.ant-spin-dot-item]:!bg-emerald-400" />
                                    </div>
                                )}
                                <PromoCard promo={promo} isLayer={true} />
                            </div>
                        ))}
                    </div>

                    <div className="mt-5 flex justify-center border-t border-white/[0.06] pt-4">
                        <Pagination
                            current={page}
                            pageSize={20}
                            total={total}
                            onChange={(newPage) => setPage(newPage)}
                            showSizeChanger={false}
                            className="pagination-custom"
                            size="small"
                        />
                    </div>
                </>
            )}
        </Modal>
    );
};

export default SubscribePromoModal;
